/* global HTMLUpdateUtility, fetchShopifyGraphQL */

/**
 * 问卷结果产品推荐组件
 * 根据用户问卷答案匹配并展示推荐产品
 */

// 问卷路径到产品映射配置
const _allowRoutes = [
  {
    path: [
      'Drinking & cooking water',
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Generous budget'
    ],
    productCode: 'x12',
    productHandle: 'reverse-osmosis-system-x12'
  },
  {
    path: [
      'Drinking & cooking water',
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Moderate budget'
    ],
    productCode: 'g3p800-w-mz',
    productHandle: 'remineralization-reverse-osmosis-system-wd-g3p800'
  },
  {
    path: [
      'Drinking & cooking water',
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Tight budget'
    ],
    productCode: 'g3p600-w-mz',
    productHandle: 'remineralization-ro-system-g3p600'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Generous budget'],
    productCode: 'g3p800',
    productHandle: 'tankless-reverse-osmosis-system-wd-g3p800-w-fc-1'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Moderate budget'],
    productHandle: 'reverse-osmosis-system-x8',
    productCode: 'x8'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Tight budget'],
    productHandle: 'waterdrop-reverse-osmosis-water-filtration-system',
    productCode: 'g3p600'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'Under the sink', 'Instant Hot'],
    productHandle: 'reverse-osmosis-instant-hot-water-dispenser-system-wd-k6-w',
    productCode: 'k6'
  },

  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Instant Hot', 'Generous budget'],
    productHandle: 'ro-hot-cold-water-dispenser-a1',
    productCode: 'a1'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Instant Hot', 'Moderate budget'],
    productHandle: 'countertop-ro-system-instant-hot-k19',
    productCode: 'k19h'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Instant Hot', 'Tight budget'],
    productHandle: 'countertop-instant-hot-ro-system-corero-system-c1h',
    productCode: 'c1h'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Instant Hot and Cold', 'Generous budget'],
    productHandle: 'ro-hot-cold-water-dispenser-a1',
    productCode: 'a1-j'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Instant Hot and Cold', 'Moderate budget'],
    productHandle: 'reverse-osmosis-hot-and-cold-water-dispenser-a2',
    productCode: 'a2'
  },
  {
    path: [
      'Drinking & cooking water',
      'Reverse Osmosis',
      'On the counter',
      'Mineral or alkaline water',
      'Generous budget'
    ],
    productHandle: 'countertop-ro-water-filter-k19-sfk',
    productCode: 'k19s-sfk'
  },
  {
    path: [
      'Drinking & cooking water',
      'Reverse Osmosis',
      'On the counter',
      'Mineral or alkaline water',
      'Moderate budget'
    ],
    productHandle: 'waterdrop-remineralization-countertop-corero-system-c1sl',
    productCode: 'c1sl'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Standard filtration', 'Generous budget'],
    productHandle: 'countertop-ro-water-filter-system-wd-k19-s',
    productCode: 'k19s'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Standard filtration', 'Moderate budget'],
    productHandle: 'countertop-ro-system-corero-system-c1s',
    productCode: 'c1s'
  },
  {
    path: ['Drinking & cooking water', 'Reverse Osmosis', 'On the counter', 'Standard filtration', 'Tight budget'],
    productHandle: 'countertop-reverse-osmosis-system-wd-n1-w',
    productCode: 'n1'
  },

  {
    path: ['Drinking & cooking water', 'Ultrafiltration', 'Generous budget'],
    productHandle: 'ultrafiltration-stainless-steel-water-filter-system-wd-tst-uf',
    productCode: 'tst-uf'
  },
  {
    path: ['Drinking & cooking water', 'Ultrafiltration', 'Moderate budget'],
    productHandle: '3-stage-ultra-filtration-under-sink-water-filter-system',
    productCode: 'tsu'
  },
  {
    path: ['Drinking & cooking water', 'Ultrafiltration', 'Tight budget'],
    productHandle: 'under-sink-ultrafiltration-water-filter-direct-connect-filtration-system',
    productCode: 'ua-uf'
  },

  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'Under the sink',
      'Mineral or alkaline water',
      'Generous budget'
    ],
    productHandle: '3-stage-under-sink-water-filter-with-dedicated-faucet-waterdrop-tsb-alk',
    productCode: 'tsa-alk'
  },
  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'Under the sink',
      'Mineral or alkaline water',
      'Tight budget'
    ],
    productHandle: 'alkaline-water-filter-system-for-sink-alk16',
    productCode: 'alk16'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'Under the sink', 'Standard filtration', 'Generous budget'],
    productHandle: 'under-counter-water-filter-system-3-stage-tsa',
    productCode: 'tsa'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'Under the sink', 'Standard filtration', 'Moderate budget'],
    productHandle: 'undersink-water-filtration-system-with-dedicated-faucet',
    productCode: 'ub'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'Under the sink', 'Standard filtration', 'Tight budget'],
    productHandle: 'under-sink-water-filter-direct-connect-filtration-system',
    productCode: 'ua'
  },

  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'On the counter',
      'Electric Water Filter Pitchers',
      'Generous budget'
    ],
    productHandle: 'countertop-electric-water-dispenser-edc01',
    productCode: 'edc01'
  },
  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'On the counter',
      'Electric Water Filter Pitchers',
      'Moderate budget'
    ],
    productHandle: 'countertop-electric-water-pitcher-ed01a',
    productCode: 'ed01a'
  },
  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'On the counter',
      'Electric Water Filter Pitchers',
      'Tight budget'
    ],
    productHandle: 'waterdrop-countertop-electric-dispenser-water-filtration-system',
    productCode: 'ed01'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'On the counter', 'Basic Pitchers', 'Generous budget'],
    productHandle: 'water-filter-dispenser',
    productCode: 'wfd-22l'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'On the counter', 'Basic Pitchers', 'Moderate budget'],
    productHandle: 'water-pitcher-with-filter',
    productCode: 'pt-07'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'On the counter', 'Basic Pitchers', 'Tight budget'],
    productHandle: 'water-filter-pitcher-chubby-blue',
    productCode: 'pt-04'
  },
  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'On the counter',
      'Faucet water filters',
      'Generous budget'
    ],
    productHandle: 'faucet-water-filtration-system-wd-ctf-01',
    productCode: 'ctf-01'
  },
  {
    path: [
      'Drinking & cooking water',
      'Carbon Filtration',
      'On the counter',
      'Faucet water filters',
      'Moderate budget'
    ],
    productHandle: 'countertop-dual-handoff-faucet-water-filter-ctf06',
    productCode: 'ctf-06'
  },
  {
    path: ['Drinking & cooking water', 'Carbon Filtration', 'On the counter', 'Faucet water filters', 'Tight budget'],
    productHandle: 'long-lasting-water-faucet-filtration-system-wd-fc-06',
    productCode: 'fc-06'
  },

  {
    path: ['Indoor water safety', 'Generous budget'],
    productHandle: 'whole-house-iron-filter-for-well-water-wd-whf3t-fg',
    productCode: 'whf3t-fg'
  },
  {
    path: ['Indoor water safety', 'Moderate budget'],
    productHandle: 'waterdrop-whf21-pg-5-micron-2-stage-wholehouse-water-filtration-system',
    productCode: 'whf21-pg'
  },
  {
    path: ['Indoor water safety', 'Tight budget'],
    productHandle: 'spin-down-filter-wd-rpfk',
    productCode: 'rpfk'
  },

  {
    path: ['Outdoor water safety', 'Generous budget'],
    productHandle: 'waterdrop-spotless-car-wash-system-with-resin',
    productCode: 'cwe'
  },
  {
    path: ['Outdoor water safety', 'Moderate budget'],
    productHandle: 'wd-tank-king-f-s',
    productCode: 'tk-s'
  },
  {
    path: ['Outdoor water safety', 'Tight budget'],
    productHandle: 'waterdrop-rvs-inline-water-filter',
    productCode: 'rv'
  },

  {
    path: ['Skin care', 'Generous budget'],
    productHandle: 'skincare-face-washer-bfc1',
    productCode: 'bfc1'
  },
  {
    path: ['Skin care', 'Moderate budget'],
    productHandle: 'skincare-face-washer-with-water-filter-faucet-bfc3',
    productCode: 'bfc3'
  },
  {
    path: ['Skin care', 'Tight budget'],
    productHandle: 'skincare-faucet-water-filter-wd-bft1',
    productCode: 'bft1'
  }
]

/**
 * 生成根据产品 handle 查询的 GraphQL 语句
 * @param {string} productHandle - 产品 handle
 * @returns {string} GraphQL 查询字符串
 */
function productByHandleGQL(productHandle) {
  return `#graphql
  query {
    product(handle: "${productHandle}") {
      handle
      title
      availableForSale
      onlineStoreUrl
      selectedOrFirstAvailableVariant {
        id
        price {
          amount
        }
        image {
          url
          altText
        }
        metafields(
          identifiers: [
            { key: "variant_price_discount", namespace: "custom" }
            { key: "variant_discount_code", namespace: "custom" }
            { key: "show_percentage_amount", namespace: "custom" }
          ]
        ) {
          value
        }
      }
    }
  }`
}

/**
 * 问卷结果展示组件
 */
class WDQuizResult extends HTMLElement {
  constructor() {
    super()

    this.productContainer = null
    this.sellingPointsPlaceholder = null
    this.recommendProductsPlaceholder = null
    this.buyButton = null
    this.cartButton = null

    this.sectionId = null

    this.fetchAbortController = null
  }

  connectedCallback() {
    this.initializeQuizResult()
    this.loadProductInfo()
  }

  disconnectedCallback() {
    this.abortPendingRequests()
  }

  /**
   * 初始化组件 DOM 引用
   */
  initializeQuizResult() {
    this.productContainer = this.querySelector('.quiz-answer-result-product')
    this.sellingPointsPlaceholder = document.querySelector('.quiz-answer-result-selling-points')
    this.recommendProductsPlaceholder = document.querySelector('.quiz-answer-result-recommend-products')

    this.sectionId = this.dataset.sectionId || null
    this.buyButton = this.querySelector(`#quiz-answer-result__button-buy-${this.sectionId}`)
    this.cartButton = this.querySelector(`#quiz-answer-result__button-cart-${this.sectionId}`)
  }

  /**
   * 取消进行中的请求
   */
  abortPendingRequests() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort()
      this.fetchAbortController = null
    }
  }

  /**
   * 根据问卷路径匹配对应的产品 handle
   * @param {string[]} quizPath - 用户问卷答案路径
   * @returns {string|null} 匹配的产品 handle
   */
  matchProductHandle(quizPath) {
    if (!quizPath || !Array.isArray(quizPath) || quizPath.length === 0) return null

    for (const route of _allowRoutes) {
      if (this.isPathMatched(quizPath, route.path)) return route.productHandle
    }

    return null
  }

  /**
   * 检查用户路径是否与配置路径完全匹配
   * @param {string[]} userPath - 用户选择的路径
   * @param {string[]} routePath - 配置的路径
   * @returns {boolean} 是否匹配
   */
  isPathMatched(userPath, routePath) {
    if (!Array.isArray(userPath) || !Array.isArray(routePath)) return false
    if (userPath.length !== routePath.length) return false
    return userPath.every((item, index) => item === routePath[index])
  }

  /**
   * 加载并显示产品信息
   */
  async loadProductInfo() {
    if (!this.productContainer) return

    const quizId = this.dataset.quizId || 'quiz'
    let storedValue = localStorage.getItem(`WD-${quizId}`)
    let isFromTagArr = false

    // 兼容：如果 WD-quizId 不存在，尝试从 tagArr 获取
    if (!storedValue) {
      const tagArrValue = localStorage.getItem('tagArr')
      if (tagArrValue) {
        storedValue = tagArrValue
        isFromTagArr = true
      } else {
        this.showEmptyState()
        return
      }
    }

    // 从 localStorage 解析问卷路径
    let quizPath
    try {
      if (isFromTagArr) {
        // tagArr 未经过 base64 编码，直接解析 JSON
        quizPath = JSON.parse(storedValue)
        // 如果是从 tagArr 获取的，移除数组最后一位（zip-code）
        if (Array.isArray(quizPath) && quizPath.length > 0) quizPath = quizPath.slice(0, -1)
      } else {
        // WD-quizId 是 base64 编码的
        quizPath = JSON.parse(decodeURIComponent(atob(storedValue)))
      }
    } catch (error) {
      console.error('Failed to parse quiz path:', error)
      this.showEmptyState()
      return
    }

    if (!quizPath || quizPath.length === 0) {
      this.showEmptyState()
      return
    }

    const productHandle = this.matchProductHandle(quizPath)
    if (!productHandle) {
      console.warn('No matching product handle found for path:', quizPath)
      this.showEmptyState()
      return
    }

    try {
      await this.fetchAndDisplayProduct(productHandle)
    } catch (error) {
      console.error('Failed to load product:', error)
      this.showEmptyState()
    }
  }

  /**
   * 显示空状态
   */
  showEmptyState() {
    if (!this.productContainer) return
    this.classList.remove('loading')
    this.parentElement.classList.add('empty')
    this.ariaHidden = true
  }

  /**
   * 获取并显示产品数据
   */
  async fetchAndDisplayProduct(productHandle) {
    this.abortPendingRequests()
    this.fetchAbortController = new AbortController()

    const query = productByHandleGQL(productHandle)

    try {
      // 通过 GraphQL 获取产品数据
      const data = await fetchShopifyGraphQL({ query }, this.fetchAbortController.signal)

      if (!data.data?.product) {
        this.showEmptyState()
        return
      }

      this.updateProductDisplay(data.data.product)
      this.renderProductSections(productHandle)
    } catch (error) {
      // 忽略用户主动取消的请求
      if (error.name === 'AbortError') return
      throw error
    } finally {
      this.fetchAbortController = null
    }
  }

  /**
   * 更新产品显示信息
   */
  updateProductDisplay(product) {
    if (!this.productContainer || !product.selectedOrFirstAvailableVariant) {
      return
    }

    const variant = product.selectedOrFirstAvailableVariant
    // 提取变体 ID（移除 Shopify GID 前缀）
    const variantId = variant.id.replace('gid://shopify/ProductVariant/', '')

    const titleEl = this.productContainer.querySelector('.quiz-answer-result__title')
    if (titleEl && product.title) {
      titleEl.textContent = product.title
    }

    const urlEl = this.productContainer.querySelector('.quiz-answer-result__link')
    if (urlEl && product.onlineStoreUrl) urlEl.href = product.onlineStoreUrl

    this.updateProductImages(product, variant)

    if (variant.price) this.updateProductPricing(variant)

    this.updateProductButtons(product, variantId)
  }

  /**
   * 更新产品图片
   */
  updateProductImages(product, variant) {
    const imgEls = this.productContainer.querySelectorAll('.quiz-answer-result__image_src')
    if (imgEls.length === 0) return

    // 优先使用变体图片，否则使用产品主图
    const imageUrl = variant.image?.url || product.featuredImage?.url || ''

    imgEls.forEach(imgEl => {
      imgEl.src = imageUrl
      imgEl.alt = product.title || ''
      imgEl.parentElement.href = product.onlineStoreUrl
    })
  }

  /**
   * 更新产品价格信息
   */
  updateProductPricing(variant) {
    const currentPriceEl = this.productContainer.querySelector('.quiz-answer-result__current-price')
    const originalPriceEl = this.productContainer.querySelector('.quiz-answer-result__original-price')
    const badgeEl = this.productContainer.querySelector('.quiz-answer-result__badge')
    const discountCodeEl = this.productContainer.querySelector('.quiz-answer-result__sale-code-value')
    const moneyFormat = this.dataset.moneyFormat || '${{amount}}'

    if (!currentPriceEl) return

    const price = Number(variant.price.amount) || 0

    // 解析折扣价格元数据（JSON 格式）
    let discountPriceMetafields = {}
    try {
      if (variant.metafields?.[0]?.value) discountPriceMetafields = JSON.parse(variant.metafields[0].value)
    } catch (error) {
      console.warn('Failed to parse discount price metafields:', error)
    }

    // 提取折扣信息：价格、折扣码、折扣类型
    const discountPrice = Number(discountPriceMetafields.amount) || 0
    const discountCode = variant.metafields?.[1]?.value || ''
    const discountType = variant.metafields?.[2]?.value || ''

    if (discountPrice > 0) {
      const discountAmount = price - discountPrice
      const formattedDiscountPrice = moneyFormat.replace('{{amount}}', discountPrice.toFixed(2))
      const formattedOriginalPrice = moneyFormat.replace('{{amount}}', price.toFixed(2))

      currentPriceEl.textContent = formattedDiscountPrice
      if (originalPriceEl) originalPriceEl.textContent = formattedOriginalPrice

      if (badgeEl && discountType) {
        const discountText =
          discountType === 'amount'
            ? `${moneyFormat.replace('{{amount}}', discountAmount.toFixed(0))} Off`
            : `${Math.floor((discountAmount / price) * 100)}% Off`
        badgeEl.textContent = discountText
      }
    } else {
      currentPriceEl.textContent = moneyFormat.replace('{{amount}}', price.toFixed(2))
    }

    if (!!discountCode && discountCodeEl?.parentElement) {
      const parentEl = discountCodeEl.parentElement
      parentEl.classList.remove('hidden')
      parentEl.ariaHidden = false
      parentEl.dataset.value = discountCode
      discountCodeEl.textContent = discountCode
    }
  }

  /**
   * 更新产品按钮状态
   */
  updateProductButtons(product, variantId) {
    if (!this.buyButton || !this.cartButton) return

    if (product.availableForSale) {
      // 更新购买链接和加购按钮数据属性
      this.buyButton.href = `${this.buyButton.href}/${variantId}:1`
      this.cartButton.dataset.atcId = variantId
      this.cartButton.dataset.atcQty = '1'
    } else {
      this.buyButton.classList.add('hidden')
      this.cartButton.textContent = 'Sold Out'
      this.cartButton.disabled = true
    }
  }

  /**
   * 获取并渲染产品相关区块（selling points 和 recommend products）
   */
  renderProductSections(productHandle) {
    this.abortPendingRequests()
    this.fetchAbortController = new AbortController()

    const url = `${this.dataset.requestUrl}/products/${productHandle}`

    fetch(url, { signal: this.fetchAbortController.signal })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(responseText => {
        // 解析 HTML 并提取产品相关区块
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const sellingSection = html.querySelector('.product-selling-points-section')
        if (sellingSection && this.sellingPointsPlaceholder) {
          HTMLUpdateUtility.setInnerHTML(this.sellingPointsPlaceholder, sellingSection.innerHTML)
        }

        const recommendSection = html.querySelector('.wd-recommend-section')
        if (recommendSection && this.recommendProductsPlaceholder) {
          HTMLUpdateUtility.setInnerHTML(this.recommendProductsPlaceholder, recommendSection.innerHTML)
        }

        this.classList.remove('loading')
        this.fetchAbortController = null
      })
      .catch(error => {
        // 忽略用户主动取消的请求
        if (error.name === 'AbortError') return
        console.error('Failed to render product sections:', error)
        this.fetchAbortController = null
      })
  }
}

// 注册自定义元素
if (!customElements.get('wd-quiz-result')) {
  customElements.define('wd-quiz-result', WDQuizResult)
}
